<div>
    <app-particular-master-form></app-particular-master-form>
</div>
<div>
    <app-particular-master-list></app-particular-master-list>
</div>